import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field, GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== password2) return setErr("Şifreler eşleşmiyor");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      toast.success("Şifreniz güncellendi, giriş yapabilirsiniz.");
      nav("/login");
    } catch (ex) {
      setErr(errMsg(ex));
    }
  };

  return (
    <AuthShell title="Yeni şifre belirle" desc="En az 6 karakter kullanın.">
      <form onSubmit={submit} className="space-y-5">
        <Field label="Yeni şifre">
          <Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-white/5" />
        </Field>
        <Field label="Yeni şifre (tekrar)">
          <Input data-testid="reset-password2" type="password" required minLength={6} value={password2} onChange={(e) => setPassword2(e.target.value)} className="h-11 bg-white/5" />
        </Field>
        {err && <div className="text-sm text-red-400" data-testid="reset-error">{err}</div>}
        <GradButton type="submit" data-testid="reset-submit" className="w-full justify-center h-11">Şifreyi güncelle</GradButton>
      </form>
      <Link to="/login" data-testid="back-to-login" className="block mt-6 text-center text-sm text-muted-foreground hover:text-white">Girişe dön</Link>
    </AuthShell>
  );
}
